import * as React from 'react';
import { ComplexValue } from 'app/types-shared';
import { ComponentProps, LabelConfig } from 'ui';
import styles from './detail-form-panel-header.scss';
import { ReactNode } from 'react';

export interface DetailFormPanelHeaderProps extends ComponentProps{
  label: LabelConfig;
  primaryKey?: ComplexValue<number>;
  children?: ReactNode;
}

export const DetailFormPanelHeader = (props: DetailFormPanelHeaderProps) => {
  const {label, primaryKey, children, componentId} = props;
  const hasVisibleChildren = React.Children.toArray(children).length > 0;
  
  return (hasVisibleChildren && 
    <div id={componentId} className={`${styles.detailFormPanelHeader}`}>
      {<h3> {label?.text} {' #'} {primaryKey?.value} </h3>}
      {React.Children?.map(children, (child, index) => (<span key={index}>{child} </span>))}
    </div>);
};
